import { LinkText } from '@/components/elements/LinkText'

export const QuestionItemList = [
  {
    questionTitle: '企業情報',
    questionList: [
      {
        id: '1',
        questionContent: <>経営方針について教えてください。</>,
        answerContent: (
          <>
            <LinkText path="/ir/manage/" text="「経営方針」" />
            からご確認いただけます。
          </>
        ),
      },
      {
        id: '2',
        questionContent: <>社名の由来は何ですか？</>,
        answerContent: (
          <>
            当社の母体である㈱トライアルカンパニーの「トライアル（TRIAL）」は、英語で「試み」や「試練」を意味し、未来に向けて不可能へ挑戦し続ける意思を表しております。
            <br />
            また、「カンパニー（COMPANY）」には、会社という意味の他に「仲間」という意味があります。困難に屈することなく、「挑戦し続ける仲間たち」、という意味が「トライアルカンパニー」という社名に込められています。
            <br />
            詳しくは、
            <LinkText path="/company/overview/" text="「会社概要」" />
            からご確認いただけます。
          </>
        ),
      },
      {
        id: '3',
        questionContent: <>経営理念について教えてください。</>,
        answerContent: (
          <>
            当社は経営理念として、パーパス・ビジョン・バリューを定めております。
            <br/>
            誕生エピソードや各項目に込めた思いなどは、
            <LinkText path="/company/philosophy/" text="「経営理念」" />
            からご確認いただけます。
          </>
        ),
      },
      {
        id: '4',
        questionContent: <>会社の設立はいつですか？</>,
        answerContent: (
          <>
            1974年福岡県福岡市において、古物商、リサイクルショップを営む「あさひ屋」を開業。1984年「㈱トライアルカンパニー」に商号変更。2015年「㈱トライアルカンパニー」を中核事業会社とする純粋持株会社「㈱トライアルホールディングス」を設立。詳しくは、
            <LinkText path="/company/history/" text="「会社沿革」" />
            からご確認いただけます。
          </>
        ),
      },
    ],
  },
  {
    questionTitle: '事業内容',
    questionList: [
      {
        id: '1',
        questionContent: <>事業概要について教えてください。</>,
        answerContent: (
          <>
            日本全国でディスカウントストアを運営している流通小売事業、流通業界に変革をもたらすAIソリューションを開発・提供するリテールAI事業を行っております。詳しくは
            <LinkText path="/business/" text="「事業内容」" />
            からご確認いただけます。
          </>
        ),
      },
    ],
  },
  {
    questionTitle: 'コーポレート・ガバナンス',
    questionList: [
      {
        id: '1',
        questionContent: (
          <>コーポレートガバナンスの考え方や体制について教えてください。</>
        ),
        answerContent: (
          <>
            当社では、株主・投資家を含むステークホルダーの皆様と協働することが、企業としての持続的な成長と企業価値向上の実現につながると考えております。そのためには、コンプライアンスの徹底、経営の透明性の確保とともに、迅速な意思決定によるスピード経営の実現が重要であり、その仕組みを構築し、機能させることをコーポレート・ガバナンスの基本的な考え方としております。詳しくは、
            <LinkText
              path="/ir/governance/basics/"
              text="「コーポレート・ガバナンスに関する基本的な考え方」"
            />
            からご確認いただけます。
          </>
        ),
      },
    ],
  },
  {
    questionTitle: '業績・財務情報',
    questionList: [
      {
        id: '1',
        questionContent: <>月次売上高は開示されていますか？</>,
        answerContent: (
          <>
            毎月10日頃に開示しております。最新の月次売上高は、
            <LinkText
              path="/ir/financial/monthly-sales/"
              text="「月次売上高速報」"
            />
            からご確認いただけます。
          </>
        ),
      },
      {
        id: '2',
        questionContent: <>主要財務指標や業績の推移はどこで確認できますか？</>,
        answerContent: (
          <>
            <LinkText path="/ir/financial/review/" text="「決算レビュー」" />
            からご確認いただけます。
          </>
        ),
      },
    ],
  },
  {
    questionTitle: 'IRライブラリー',
    questionList: [
      {
        id: '1',
        questionContent: <>最新の決算情報は、どこで見ることができますか？</>,
        answerContent: (
          <>
            <LinkText
              path="/ir/library/financial-announcement/"
              text="「決算関連資料」"
            />
            からご確認いただけます。また、決算に関するダイジェストは
            <LinkText path="/ir/financial/review/" text="「決算レビュー」" />
            からご確認いただけます。
          </>
        ),
      },
      {
        id: '2',
        questionContent: (
          <>
            IR資料（決算短信、有価証券報告書等）は、どこで見ることができますか？
          </>
        ),
        answerContent: (
          <>
            <LinkText path="/ir/library/" text="「IRライブラリー」" />
            からご確認いただけます。
          </>
        ),
      },
    ],
  },
  {
    questionTitle: '株式情報',
    questionList: [
      {
        id: '1',
        questionContent: <>株価の推移はどうなっていますか?</>,
        answerContent: (
          <>
            <LinkText path="/ir/stock/price/" text="「株価情報」" />
            からご確認いただけます。
          </>
        ),
      },
      {
        id: '2',
        questionContent: <>1単元の株式数は何株ですか？</>,
        answerContent: <>100株です。</>,
      },
      {
        id: '3',
        questionContent: <>上場している証券取引所はどこですか？</>,
        answerContent: <>東京証券取引所のグロース市場に上場しております。</>,
      },
      {
        id: '4',
        questionContent: <>株式が上場したのはいつですか？</>,
        answerContent: <>2024年3月21日です。</>,
      },
      {
        id: '5',
        questionContent: <>証券コードを教えてください。</>,
        answerContent: <>141Aです。</>,
      },
      {
        id: '6',
        questionContent: <>株式事務の諸手続きについて教えてください。</>,
        answerContent: (
          <>
            口座の種類によってお手続きが異なります。詳しくは
            <LinkText path="/ir/stock/info/" text="「株式基本情報」" />
            をご確認ください。
          </>
        ),
      },
      // 2023年４月時点では非公開とのこと
      // {
      //   id: '7',
      //   questionContent: <>株主構成はどこで確認できますか？</>,
      //   answerContent: (
      //     <>
      //       大株主の一覧や所有者別分布状況等の情報については、
      //       <Link href="/ir/stock/situation/" passHref>
      //         <a>「株式の状況」</a>
      //       </Link>
      //       からご確認いただけます。
      //     </>
      //   ),
      // },
      {
        id: '8',
        questionContent: <>株主総会はいつですか？</>,
        answerContent: (
          <>
            定時株主総会は毎年9月下旬頃に開催予定です。
            <br />
            株主総会招集通知は
            <LinkText path="/ir/stock/meeting/" text="「株主総会」" />
            をご覧ください。
          </>
        ),
      },
      {
        id: '9',
        questionContent: <>配当金の受取方法について教えて下さい。</>,
        answerContent: (
          <>
            配当金の受取方法は以下の方法があります。
            <br />
            ・証券会社の口座に記録された株式数に応じた配当金を、その証券会社の口座において受領する方法（株式数比例配分方式）
            <br />
            ・すべての配当金を一つの金融機関の口座で受領する方法（登録配当金受領口座方式）
            <br />
            ・郵便局等の窓口で受領する方法（配当金領収証方式） <br />
            ・銘柄ごとに口座振込指定をし、指定した金融機関で受領する方法（個別銘柄指定方式）
            <br />
            ※配当金の受取方法の指定、変更は、お取引口座のある証券会社までお申し出ください。
            （特別口座の株主様は特別口座管理人である三菱UFJ信託銀行までお申し出ください。）
            <br />※詳細については、当社株主名簿管理人である
            <LinkText
              path="https://www.tr.mufg.jp/daikou/kabu_qa_07.html"
              text="「三菱UFJ信託銀行のウェブサイト」"
              target="_blank"
            />
            にてご確認ください。
          </>
        ),
      },
    ],
  },
  {
    questionTitle: '配当・株主還元',
    questionList: [
      {
        id: '1',
        questionContent: <>配当政策について教えて下さい。</>,
        answerContent: (
          <>
            配当政策については、
            <LinkText path="/ir/stock/dividend/" text="「配当・株主還元」" />
            からご確認ください。
          </>
        ),
      },
      {
        id: '2',
        questionContent: <>配当基準日はいつですか？</>,
        answerContent: (
          <>
            毎年6月30日です。中間配当金の支払いを行う場合は12月31日としております。詳細は、
            <LinkText path="/ir/stock/dividend/" text="「配当・株主還元」" />
            からご確認ください。
          </>
        ),
      },
      {
        id: '3',
        questionContent: <>中間配当はありますか。</>,
        answerContent: <>現時点では、予定しておりません。</>,
      },
      {
        id: '4',
        questionContent: <>株主優待制度はありますか？</>,
        answerContent: <>株主優待制度はございません。</>,
      },
    ],
  },
  {
    questionTitle: 'IRカレンダー',
    questionList: [
      {
        id: '1',
        questionContent: <>決算期はいつですか？</>,
        answerContent: <>毎年6月30日です。</>,
      },
      {
        id: '2',
        questionContent: <>IRスケジュールを教えてください。</>,
        answerContent: (
          <>
            <LinkText path="/ir/calendar/" text="「IRカレンダー」" />
            に掲載しております。
          </>
        ),
      },
    ],
  },
  {
    questionTitle: 'お問い合わせ',
    questionList: [
      {
        id: '1',
        questionContent: <>IRに関する問合せはどこからできますか。</>,
        answerContent: (
          <>
            <LinkText path="/contact/ir/" text="「IRお問合せ」" />
            からご連絡いただけます。
          </>
        ),
      },
    ],
  },
]
